import { Category, Product, ShopProduct } from "core/catalog";
import { Order } from "core/orders";

export const URLS = {
  home: "/",
  auth: {
    login: "/login",
    register: "/register",
    forgetPassword: "/forget-password",
    resetPassword: "/reset-password",
    verifyEmail: "/verify-email",
  },
  infoPages: {
    aboutUs: "/about-us",
    termsConditions: "/terms-conditions",
    privacyPolicy: "/privacy-policy",
    exchangeAndReturnPolicy: "/exchange-and-return-policy",
    viewRoute: "/info-pages/:slug/:id",
    view: (page: any) => `/info-pages/${page.id}/${page.slug}`,
  },
  ourCakes: {
    list: "/shop",
    categoriesLayout: "/categories",
    viewRoute: "/shop/:slug/:id",
    view: (cake: Product | ShopProduct) => `/shop/${cake.id}/${cake.slug}`,
    viewProduct: (product: Product) =>
      `/shop/${product.id}/${product.slug}`,
    relatedProducts: (productId: number) =>
      `/shop/${productId}/related-products`,
    similarProducts: (productId: number) =>
      `/shop/${productId}/similar-products`,
    viewCategory: (categoryId: string, categorySlug: string) =>
      `/categories/${categoryId}/${categorySlug}`,
  },
  flavorList: {
    list: "/flavor-list",
    viewRoute: "/flavor-list/:slug/:id",
    view: (flavor: any) => `/flavor-list/${flavor.id}/${flavor.slug}`,
  },
  contactUs: "/contact-us",
  account: {
    root: "/account",
    addresses: "/account/addresses",
    orders: "/account/orders",
    viewOrder: (order: Order) => `/account/orders/${order.id}`,
    changePassword: "/account/update-password",
  },
  cart: {
    root: "/cart",
    api: "/cart/api",
  },

  // api
  api: {
    invalidate: "/api/invalidate",
  },

  // Global
  uploads: "/uploads",
  maintenance: "/maintenance",
};
